import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestChangePassword(data) {
    return fetch.put(`${BASE_URL}/api/auth/changePassword`, data);
}

